import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { TextField, TextFieldProps } from '../text-field';
import { getSecurityCodeParser } from './parse';

type PrepaidCardPinFieldProps = TextFieldProps & {
  codeLength?: number;
};

export const PrepaidCardPinField = (props: PrepaidCardPinFieldProps) => {
  const { codeLength = 4, ...restProps } = props;
  const intl = useIntl();
  const parse = useMemo(() => getSecurityCodeParser(codeLength), [codeLength]);

  return (
    <TextField
      type="password"
      inputProps={{
        inputMode: 'numeric',
        autoComplete: 'on',
        autocompletetype: 'cc-csc',
        pattern: '\\d*',
      }}
      autoComplete="on"
      fieldProps={{
        parse,
      }}
      label={intl.formatMessage({
        id: 'payments:prepaid:pin-number-field-label',
        defaultMessage: 'PIN Number',
        description: 'PIN number field label',
      })}
      {...restProps}
    />
  );
};
